<div
  class="group relative overflow-hidden h-full rounded-xl bg-gradient-to-br p-6 shadow-lg transition-all duration-300 hover:shadow-xl"
  [class]="getColorClasses().gradient + ' hover:shadow-' + color() + '-100'"
>
  <div
    class="absolute bottom-0 left-0 h-2 w-full bg-gradient-to-r"
    [class]="getColorClasses().accent"
  ></div>
  <div class="flex items-center">
    <div
      class="mr-4 flex h-14 w-14 items-center justify-center rounded-full"
      [class]="getColorClasses().icon"
    >
      <i
        class="pi text-2xl"
        [class]="icon()"
      ></i>
    </div>
    <div>
      <div [class]="'text-4xl font-bold ' + getColorClasses().text">
        {{ value() }}
        @if (suffix()) {
          <span [class]="suffixClass()">{{ suffix() }}</span>
        }
      </div>
      <div class="mt-1 text-sm font-medium text-gray-600 dark:text-gray-400">{{ label() }}</div>
    </div>
  </div>
</div>
